import offerContractKeys from 'features/localization/keys/OffersContracts.json';
import commonKeys from 'features/localization/keys/Common.json';


export enum DisplayContractsEnum {
    withNonZeroQuantities = 1,
    withZeroQuantities,
    all,
    archived,
}

export function getDisplayContractsName(displayContracts: DisplayContractsEnum): string {
    switch (displayContracts) {
        case DisplayContractsEnum.withNonZeroQuantities:
            return offerContractKeys["DisplayContractsEnum_Value_Open"];
        case DisplayContractsEnum.withZeroQuantities:
            return offerContractKeys["DisplayContractsEnum_Value_Closed"];
        case DisplayContractsEnum.archived:
            return offerContractKeys["DisplayContractsEnum_Value_Archived"];
        case DisplayContractsEnum.all:
            return commonKeys["Value_All"];
        default:
            return "";
    }
}

export const AllDisplayContractsEnums: DisplayContractsEnum[] = [
    DisplayContractsEnum.withNonZeroQuantities,
    DisplayContractsEnum.withZeroQuantities,
    DisplayContractsEnum.all
]

export const CashDisplayContractsEnums: DisplayContractsEnum[] = [
    DisplayContractsEnum.withNonZeroQuantities,
    DisplayContractsEnum.archived,
    DisplayContractsEnum.all
]

export class DisplayContractsType {
    id: number = 0;
    name: string = "";
}

export const AllDisplayContractsType: DisplayContractsType[] = AllDisplayContractsEnums.map(id => ({ id, name: getDisplayContractsName(id) }));
export const CashDisplayContractsType: DisplayContractsType[] = CashDisplayContractsEnums.map(id => ({ id, name: getDisplayContractsName(id) }));